/**
 * List of all english error messages by error code 
 */
const _messagesEN = {
    400: "The request is invalid (usually with wrong parameters)",
    401: "Authentication is required",
    403: "Access denied",
    404: "Resource was not Found",
    408: "The request took too long and timed out",
    409: "Request is in conflict with server state",
    413: "Request Payload Too Large",

    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service unavailable",
    504: "Gateway Timeout",
    580: "SQL Error",
    581: "SQL Wrapper Error",
    582: "SQL Parameter Error"
};

type ErrorMessageRecord = typeof _messagesEN;

/**
 * List of all french error messages by error code 
 */
const _messagesFR: ErrorMessageRecord = {
    400: "La requête est invalide (cause probable : les paramètres sont incorrects)",
    401: "Identification requise",
    403: "Accès refusé",
    404: "Ressource non trouvée",
    408: "La requête prend trop de temps",
    409: "La requête était en conflit avec l'état du serveur",
    413: "Taille de requête trop élevée",

    500: "Erreur interne du serveur",
    502: "Erreur de communication avec le serveur (Bad Gateway)",
    503: "Serveur indisponible",
    504: "Erreur de communication avec le serveur (Gateway Timeout)",
    580: "Erreur SQL",
    581: "Erreur SQL lors de la conversion des données depuis la base de données",
    582: "Erreur des paramètres SQL"
};

/**
 * Route related error messages per language and per code (messages["fr"][404])
 */
export const ERROR_MESSAGES = {
    "en": _messagesEN,
    "fr": _messagesFR
};